module.exports = __webpack_public_path__ + "img/TIF_Claims_Logo.205bf76d.png";